import { delay, put, takeLatest } from '@redux-saga/core/effects';
import { browserHistory } from 'react-router';
import ROUTES from '../../../constants/routes';

import * as userRegistration from './user-registration-req';
import * as success from '../../ui/success';

export function* userRegistrationWorker() {
  yield put({
    type: success.consts.UPDATE,
    payload: { id: 'auth.signup.registrationInvitation' },
  });
  yield browserHistory.push(ROUTES.LOGIN);
}

export default function* userRegistrationSaga() {
  yield takeLatest(userRegistration.consts.SUCCEED, userRegistrationWorker);
}



// WEBPACK FOOTER //
// ./src/redux/auth/signup/user-registration-saga.js